import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';

export const ShowMoreBlock = styled.div`
  position: relative;
  top: ${({ small }) => (small ? '-6px' : 0)};
  ${({ small }) => (small ? getFont(-1) : getFont(0))};
  color: ${({ theme, light }) => (light ? theme.colors.fontL : theme.mainColor)};
  text-align: center;
`;
